(async () => {
  if (document.documentElement.dataset.purchaseDisabled !== 'true') {
    try {
      const root = window.Shopify?.routes?.root || '/';
      const response = await fetch(`${root}browsing_context_suggestions.json?country%5Benabled%5D=true`);
      if (!response.ok) return;

      const context = await response.json();
      if (context.detected_values?.country?.handle !== 'JP') return;

      document.documentElement.dataset.purchaseDisabled = 'true';
    } catch {
      return;
    }
  }

  const purchaseButtonSelector = [
    'form[action*="/cart/add"] button[type="submit"]',
    '[data-launch-checkout-form] button[type="submit"]',
    'button[name="checkout"]',
    '.shopify-payment-button button',
    '.additional-checkout-buttons button',
  ].join(',');
  const acceleratedCheckoutSelector = '.shopify-payment-button, .additional-checkout-buttons';

  function disableButton(button) {
    if (!(button instanceof HTMLButtonElement) || button.disabled) return;

    button.disabled = true;
  }

  function disableAcceleratedCheckout(container) {
    if (!(container instanceof HTMLElement) || container.inert) return;

    container.inert = true;
    container.setAttribute('aria-disabled', 'true');
  }

  function disablePurchaseControls(scope = document) {
    if (scope instanceof Element && scope.matches(purchaseButtonSelector)) {
      disableButton(scope);
    }
    if (scope instanceof Element && scope.matches(acceleratedCheckoutSelector)) {
      disableAcceleratedCheckout(scope);
    }

    scope.querySelectorAll?.(purchaseButtonSelector).forEach(disableButton);
    scope.querySelectorAll?.(acceleratedCheckoutSelector).forEach(disableAcceleratedCheckout);
  }

  function isBlockedPurchaseForm(form, submitter) {
    if (form.matches('[data-launch-checkout-form], form[action*="/cart/add"]')) return true;
    return submitter instanceof HTMLButtonElement && submitter.name === 'checkout';
  }

  disablePurchaseControls();

  document.addEventListener(
    'submit',
    (event) => {
      if (!(event.target instanceof HTMLFormElement)) return;
      if (!isBlockedPurchaseForm(event.target, event.submitter)) return;

      event.preventDefault();
      event.stopImmediatePropagation();
    },
    true,
  );

  document.addEventListener(
    'click',
    (event) => {
      if (!(event.target instanceof Element)) return;
      if (!event.target.closest(`${purchaseButtonSelector},${acceleratedCheckoutSelector}`)) return;

      event.preventDefault();
      event.stopImmediatePropagation();
    },
    true,
  );

  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.type === 'attributes') {
        if (mutation.target instanceof Element && mutation.target.matches(purchaseButtonSelector)) {
          disableButton(mutation.target);
        }
        return;
      }

      mutation.addedNodes.forEach((node) => {
        if (node instanceof Element) disablePurchaseControls(node);
      });
    });
  });

  observer.observe(document.body, {
    attributes: true,
    attributeFilter: ['disabled'],
    childList: true,
    subtree: true,
  });

  window.addEventListener('pageshow', () => disablePurchaseControls());
})();
